<template>
  <div class="content">
    <PageHeader :breadcrumbLinks="breadcrumbLinks" title="Relatório" :subtitle="this.$route.params.title" />
    <div class="page-content container-fluid">
      <div class="card card-tabs flex-row">
        <div class="painel-stat" :class="{ 'qf-visible': isStatistics }">
          <div class="card-body block-el">
            <router-view
              ref="view"
              :date-gte="dateGte"
              :date-lte="dateLte"
              @data-loaded="dataLoaded"
              />
          </div>
        </div>
        <div
          class="quick-filters"
          :class="{
            'd-none': !isStatistics,
            'show': quickFilterVisible
          }">

          <!-- social -->
          <div class="qf-item" :class="{ active: quickFilterActive === 'events' }">
            <div class="qf-timeline">
              <div class="qf-icon badge bg-secondary">
                <span class="material-symbols-outlined">share</span>
              </div>
              <hr>
            </div>
            <div class="qf-loading d-flex align-items-center justify-content-center" v-if="loadingSocial">
              <LoadingAnim />
            </div>
            <div v-else>
              <h4>Informação por Rede social</h4>
              <p>{{ social.length > 0 && social[0].group_by ? social[0].group_by : 'N/A' }}</p>
              <div
                class="progress"
                role="progressbar"
                aria-label="Basic example"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100">
                <div class="progress-bar" style="width: 45%">{{social.length > 0 && social[0].values[0][1] ? social[0].values[0][1] : 0 }}</div>
              </div>
              <footer>
                <h5 class="text-center">Processo estimado</h5>
                <p class="text-center">Últimos 30 dias</p>
              </footer>
              <button
                :class="['details btn btn-light', { btn_active: quickFilterActive === 'events' }]"
                :style="quickFilterActive === 'events' ? 'color: white!important' : ''"
                @click="chooseChart('events')">
                Ver Detalhes
                <span class="material-icons-outlined">east</span>
              </button>
            </div>
          </div>

          <!-- os -->
          <div class="qf-item" :class="{ active: quickFilterActive === 'devices' }">
            <div class="qf-timeline">
              <div class="qf-icon badge bg-secondary">
                <span class="material-icons-outlined">devices</span>
              </div>
              <hr>
            </div>
            <div class="qf-loading d-flex align-items-center justify-content-center" v-if="loadingOs">
              <LoadingAnim />
            </div>
            <!-- <div v-else> -->
              <div v-else>
              <h4>Informação por Sistema operacional</h4>
              <p>{{ os.length > 0 && os[0].group_by ? os[0].group_by : 'N/A' }}</p>
              <div
                class="progress"
                role="progressbar"
                aria-label="Basic example"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100">
                <div class="progress-bar" style="width: 45%">{{os.length > 0 && os[0].values[0][1] ? os[0].values[0][1] : 0 }}</div>
              </div>
              <footer>
                <h5 class="text-center">Processo estimado</h5>
                <p class="text-center">Últimos 30 dias</p>
              </footer>
              <button
                :class="['details btn btn-light', { btn_active: quickFilterActive === 'devices' }]"
                :style="quickFilterActive === 'devices' ? 'color: white!important' : ''"
                @click="chooseChart('devices')">
                Ver Detalhes
                <span class="material-icons-outlined">east</span>
              </button>
            </div>
          </div>

          <!-- cidade -->
          <div class="qf-item" :class="{ active: quickFilterActive === 'providers' }">
            <div class="qf-timeline">
              <div class="qf-icon badge bg-secondary">
                <span class="material-symbols-outlined">location_on</span>
              </div>
              <hr>
            </div>
            <div class="qf-loading d-flex align-items-center justify-content-center" v-if="loadingCity">
              <LoadingAnim />
            </div>
            <!-- <div v-else> -->
              <div v-else>
              <h4>Informação por Cidade</h4>
              <p>{{ city.length > 0 && city[0].group_by ? city[0].group_by : 'N/A' }}</p>
              <div
                class="progress"
                role="progressbar"
                aria-label="Basic example"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100">
                <div class="progress-bar" style="width: 45%">{{city.length > 0 && city[0].values[0][1] ? city[0].values[0][1] : 0 }}</div>
              </div>
              <footer>
                <h5 class="text-center">Processo estimado</h5>
                <p class="text-center">Últimos 30 dias</p>
              </footer>
              <button
                :class="['details btn btn-light', { btn_active: quickFilterActive === 'providers' }]"
                :style="quickFilterActive === 'providers' ? 'color: white!important' : ''"
                @click="chooseChart('providers')">
                Ver Detalhes
                <span class="material-icons-outlined">east</span>
              </button>
            </div>
          </div>

          <!-- país -->
          <div class="qf-item" :class="{ active: quickFilterActive === 'browsers' }">
            <div class="qf-timeline">
              <div class="qf-icon badge bg-secondary">
                <span class="material-symbols-outlined">public</span>
              </div>
              <hr>
            </div>
            <div class="qf-loading d-flex align-items-center justify-content-center" v-if="loadingCountry">
              <LoadingAnim />
            </div>
            <div v-else>
              <h4>Informação por País</h4>
              <p>{{ country.length > 0 && country[0].group_by ? country[0].group_by : 'N/A' }}</p>
              <div
                class="progress"
                role="progressbar"
                aria-label="Basic example"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100">
                <div class="progress-bar" style="width: 45%">{{country.length > 0 && country[0].values[0][1] ? country[0].values[0][1] : 0 }}</div>
              </div>
              <footer>
                <h5 class="text-center">Processo estimado</h5>
                <p class="text-center">Últimos 30 dias</p>
              </footer>
              <button
                :class="['details btn btn-light', { btn_active: quickFilterActive === 'browsers' }]"
                :style="quickFilterActive === 'browsers' ? 'color: white!important' : ''"
                @click="chooseChart('browsers')">
                Ver Detalhes
                <span class="material-icons-outlined">east</span>
              </button>
            </div>
          </div>

          <header class="p-2">
            <button
              class="btn btn-light"
              @click="quickFilterVisible = false">
              <span class="material-icons-outlined">close</span>
            </button>
          </header>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import moment from 'moment';
import PageHeader from '@/components/rebranding/PageHeader.vue';
import LoadingAnim from '@/components/rebranding/animLottie/Loading.vue';

export default {
  name: 'OmniReports',
  components: {
    // Card,
    PageHeader,
    LoadingAnim,
  },
  watch: {
    $route(to, from) {
      this.$nextTick(() => console.log('$route:://', this.$refs.view));
    },
  },
  computed: {
    isStatistics() {
      return this.$route.path.indexOf('/stat') !== -1;
    },

    view() {
      return this.$refs?.view || {};
    },

    viewStatus() {
      // dataSentMessages
      // dataMessagesEvents
      // dataMessagesProviders
      // dataMessagesDevices
      // dataMessagesBrowsers
      const items = this.dataSentMessages;

      return [this.loadingEvents, items];
    },

    loadingEvents() {
      this.localTick;
      return this.$refs?.view?.loadingEvents ?? true;
    },
    loadingProviders() {
      this.localTick;
      return this.$refs?.view?.loadingProviders ?? true;
    },
    loadingDevices() {
      this.localTick;
      return this.$refs?.view?.loadingDevices ?? true;
    },
    loadingBrowsers() {
      this.localTick;
      return this.$refs?.view?.loadingBrowsers ?? true;
    },

    viewEvents() {
      this.localTick;

      const items = this.$refs?.view?.dataMessagesEvents ?? [];

      return items.reduce((a, item) => {
        const sum = item?.values?.reduce((b, value) => b + value?.[1] ?? 0, 0);
        return a + sum;
      }, 0);
    },
    viewProviders() {
      this.localTick;

      const items = this.$refs?.view?.dataMessagesProviders ?? [];

      return items.reduce((a, item) => {
        const sum = item?.values?.reduce((b, value) => b + value?.[1] ?? 0, 0);
        return a + sum;
      }, 0);
    },
    viewDevices() {
      this.localTick;

      const items = this.$refs?.view?.dataMessagesDevices ?? [];

      return items.reduce((a, item) => {
        const sum = item?.values?.reduce((b, value) => b + value?.[1] ?? 0, 0);
        return a + sum;
      }, 0);
    },
    viewBrowsers() {
      this.localTick;

      const items = this.$refs?.view?.dataMessagesBrowsers ?? [];

      return items.reduce((a, item) => {
        const sum = item?.values?.reduce((b, value) => b + value?.[1] ?? 0, 0);
        return a + sum;
      }, 0);
    },
    humanRangeDate() {
      const base = 86400000;
      const dateLte = this.dateLte.replace(/\s\d{1,2}[:]\d{1,2}[:]\d{1,2}$/, '');
      const dateGte = this.dateGte.replace(/\s\d{1,2}[:]\d{1,2}[:]\d{1,2}$/, '');

      if (dateLte === dateGte) return 'Hoje';

      const lte = new Date(this.dateLte);
      const gte = new Date(this.dateGte);

      let diff = Math.round((gte - lte) / base, 0);

      if (diff < 0) diff *= -1;

      if (diff === 1) return 'No útlimo dia';

      if (diff < 31) return `Útlimos ${diff} dias`;

      return `Útlimos ${Math.round(diff / 12, 0)} mese(s)`;
    },
  },
  data() {
    const today = moment();

    return {
      breadcrumbLinks: {
        1: '/shortener/links',
        2: '',
      },

      localTick: 0,
      quickFilterActive: 'status',
      quickFilterVisible: false,
      calendarOpts: {
        timePicker: false,
        autoApply: true,
        className: 'form-control',
        maxSpan: {
          days: 31,
        },
        locale: {
          format: 'DD/MM/YYYY',
          daysOfWeek: ['Do', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sa'],
          monthNames: [
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Mai',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Out',
            'Nov',
            'Dez',
          ],
        },
        message: '',
      },
      dateGte: today.format('YYYY-MM-DD 00:00:00'),
      dateLte: today.format('YYYY-MM-DD 23:59:59'),
      social: [
        {
          group_by: 'N/A',
          values: [
            ['N/A', 0],
            ['N/A', 0],
          ],
        },
      ],
      os: [
        {
          group_by: 'N/A',
          values: [
            ['N/A', 0],
            ['N/A', 0],
          ],
        },
      ],
      city: [
        {
          group_by: 'N/A',
          values: [
            ['N/A', 0],
            ['N/A', 0],
          ],
        },
      ],
      country: [
        {
          group_by: 'N/A',
          values: [
            ['N/A', 0],
            ['N/A', 0],
          ],
        },
      ],
      loadingSocial: true,
      loadingOs: true,
      loadingCity: true,
      loadingCountry: true,
    };
  },
  filters: {
    humanSize: (value) => {
      if (!value) return 0;

      if (value < 1000) return value;

      let base = 1;
      let sulfix = '';

      if (value >= 1000000000) {
        base = 1000000000;
        sulfix = 'Bilhão(ões)';
      } else if (value >= 1000000) {
        base = 1000000;
        sulfix = 'Milhão(ões)';
      } else if (value >= 1000) {
        base = 1000;
        sulfix = 'Mil';
      }

      // return `${[value, base]} Mil`;
      return `${(value / base).toFixed()} ${sulfix}`;
    },
  },
  // Pai
  methods: {
    dataLoaded() {
      this.fetchReports();
    },
    chooseChart(chart) {
      console.log('chart', chart);
      this.quickFilterVisible = false;
      this.quickFilterActive = chart;
      this.$refs.view.choose(chart);
    },
    refresh() {
      console.log('this.$refs.loadingEvents//refresh', this.loadingEvents);
      this.$refs.view?.fetch(() => {
        this.localTick += 1;
        console.log('localTick', this.localTick);
      });
    },
    fetchReports() {
      this.social = this.$refs?.view?.dataMessagesEvents;
      this.loadingSocial = false;
      this.os = this.$refs?.view?.dataMessagesDevices;
      this.loadingOs = false;
      this.city = this.$refs?.view?.dataMessagesProviders;
      this.loadingCity = false;
      this.country = this.$refs?.view?.dataMessagesBrowsers;
      this.loadingCountry = false;

      // console.log('AQUI O OS -->', this.os[0]);
    },
    changeDate(date) {
      console.log('changeDate', date);

      if (date?.length !== 2) {
        const today = moment().format('DD/MM/YYYY');
        date = [today, today];
      }

      this.dateGte = moment(date[0], 'DD/MM/YYYY').format('YYYY-MM-DD 00:00:00');
      this.dateLte = moment(date[1], 'DD/MM/YYYY').format('YYYY-MM-DD 23:59:59');
      this.refresh();
    },
    exportData(format) {
      this.$refs.view.exportData(format);
    },
  },
};
</script>
<style lang="scss" scoped>
.btn_active {
  background-color: #752de6 !important;
  color: white !important;
}

.btn_active:hover {
  background-color: #752de6 !important;
  color: white !important;
}
.painel-stat {
  width: 100% !important;

  &.qf-visible {
    width: calc(100% - 400px);
  }

  @media (max-width: 1200px) {
    width: 100% !important;
  }
}

.quick-filters-open {
  display: none;

  @media (max-width: 1200px) {
    display: block;
  }
}

.quick-filters {
  background-color: #fff;
  border-left: thin solid #ededed;
  padding: 30px;
  width: 100%;
  max-width: 400px;
  min-width: 320px;
  position: relative;
  z-index: 10;

  @media (max-width: 1200px) {
    box-shadow: 0 -3px 15px rgba(0, 0, 0, .1);
  }

  & > header {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    text-align: right;
    display: none;

    .btn {
      padding: 0;
      height: 42px;
      width: 42px;
      font-weight: bold;
      font-size: 1.5rem;
    }
  }

  @media (max-width: 1200px) {
    display: none;
    overflow-x: hidden;
    overflow: auto;
    position: fixed;
    right: 0;
    top: 62px;
    height: calc(100% - 62px);
    height: calc(100vh - 62px);

    & > header {
      display: block;
    }

    &.show {
      display: block;
    }
  }

  .qf-item {
    background-color: rgba(0,0,0,0);
    border-radius: .4rem;
    height: 200px;
    position: relative;

    .details {
      position: absolute;
      right: 10px;
      bottom: 10px;
      color: var(--clr-yup-purple) !important;

      span {
        color: inherit;
        vertical-align: middle;
        font-size: 1.5em;
      }
    }

    p {
      margin-bottom: .1rem;
    }

    h4 {
      font-size: .82rem;
    }

    .qf-icon, hr {
      background: #ccc !important;
      transition: .1s ease-in;
    }

    &.active, &:hover {
      .qf-icon, hr {
        background: var(--clr-yup-purple) !important;
      }
    }

    .progress-bar {
      border-radius: 10px;
      padding-right: .72rem;
      text-align: right;
    }

    .qf-icon {
      color: #fff;
      font-size: 1.5rem;
      height: 40px;
      width: 40px;
    }

    .qf-loading {
      height: 100%;
    }

    .qf-timeline {
      width: 80px;
      height: 100%;
      float: left;

      & + div {
        width: calc(100% - 80px);
        float: right;
      }

      hr {
        position: absolute;
        left: 19px;
        top: 40px;
        border-radius: 10px;
        height: calc(100% - 75px);
        width: 4px;
      }
    }

    footer {
      margin-top: .5rem;
      font-size: .64em;

      h5 {
        font-weight: bold;
      }

      h5, p {
        font-size: 1em;
      }
    }
  }
}

.table-responsive {
  min-height: 150px;
}

.nav-actions {
  list-style-type: none;
  margin: 0;

  & > li {
    padding: .5rem;

    &:first-child {
      padding-right: 0;
    }

    &::v-deep {
      .btn {
        position: relative;
        font-size: 1.5rem;
        padding: .5rem;
        height: auto;
        display: flex;

        &.calendar {
          input {
            cursor: pointer;
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
          }
        }
      }

      .dropdown-menu {
        left: 0px !important;
      }
    }
  }
}

/* Rebranding */
.card.card-tabs .card-header {
  & > .full {
    width: 100%;
    padding: 0 1rem;
    gap: 2.5rem;
    margin-bottom: 5px;
    border-bottom: 2px solid rgba(210, 221, 234, 0.5);
  }

  .nav.nav-tabs {
    border-bottom: none;
    margin-bottom: 0;
    gap: 2.5rem;
  }
}

.card.card-tabs .card-header .nav.nav-tabs li a {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 1.4rem 0.7rem 1.3rem;
  color: var(--clr-light-2);
}
.nav.nav-tabs .nav-item .nav-link.router-link-exact-active {
  color: var(--clr-yup-purple) !important;
  border-bottom: solid 2px var(--clr-yup-purple);
}

.nav.nav-tabs .nav-item .nav-link.router-link-exact-active i {
  color: var(--clr-yup-purple) !important;
}

.card.card-tabs .card-header .nav.nav-tabs li a i {
  font-size: 24px;
}

.nav-tabs .nav-item {
  margin-bottom: -2px;
}
.nav-tabs {
  border-bottom: 2px solid rgba(210, 221, 234, 0.5);
}

.rebranding .card .opts_card i {
  font-size: 22px;
  transition: 0.5s;
  padding: 5px;
}

.rebranding .card .opts_card i:hover {
  background-color: var(--background-icon-hover);
  border-radius: 5px;
}

.calendar_form {
  position: absolute;
  right: 70px;
  width: 38px;
  opacity: 0;
}

.calendar_form:hover ~ .calendar_icon,
.calendar_form:focus-within ~ .calendar_icon {
  background-color: var(--background-icon-hover);
  border-radius: 5px;
}

.calendar_form input {
  cursor: pointer;
  width: 38px;
}

/* Card-tabs mobile */
@media (max-width: 767.98px) {
  .card-tabs .nav-link span:last-of-type:not(.card-tabs .nav-link.router-link-active span) {
    display: none;
  }
  .card.card-tabs .card-header .nav.nav-tabs li a {
    transform: scale(1.1);
    height: 40px;
    padding: 20px 5px !important;
    padding-top: 30px !important;
  }
  .card.card-tabs .card-header .nav.nav-tabs {
    justify-content: space-between;
    gap: 5px !important;
  }
  .rebranding .card .opts_card {
    justify-content: flex-end;
    margin-left: unset !important;
    width: 100%;
    padding-top: 10px;
  }
  .rebranding .card .opts_card span {
    font-size: 26px;
    padding-top: 0;
  }
}
</style>
